import styled from 'styled-components'

import { PrimaryButton } from 'components/core/Buttons'

import SubmissionCardLeft from './SubmissionCardLeft'
import { trpc } from '~/utils/trpc'

import { DEFAULT_CHAIN_ID } from 'config'
import Link from 'next/link'

export const SubmissionCardOuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  align-self: center;
`
export const SubmissionCardDiv = styled.div`
  display: flex;
  flex-direction: row;

  background: rgba(0, 0, 0, 0.32);

  box-shadow: inset 0px -1px 0px rgba(255, 255, 255, 0.25), inset 0px 2px 2px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(62px);
  border-radius: 64px;

  padding: 32px;

  align-self: center;
  width: 95%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
    width: 100%;
  `};
`

export const SubmissionCardImage = styled.img`
  border-radius: 32px;
  width: 45%;
  object-fit: cover;
  aspect-ratio: 1/1;

  overflow: hidden;
  border-radius: 32px;

  background: #ffffff;

  box-shadow: -1px -3px 4px rgba(255, 255, 255, 0.2), 0px 16px 32px rgba(27, 26, 37, 0.24),
    0px 12px 24px rgba(27, 26, 37, 0.16), 0px 4px 8px rgba(27, 26, 37, 0.12);

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
    align-self: center;
  `};
`

export const MobileButtonsDiv = styled.div`
  flex-direction: row;
  align-items: center;
  gap: 12px;
  display: none;
  margin-top: 16px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: flex;
    `};
`

export function SubmissionMobileButtons() {
  return (
    <MobileButtonsDiv>
      <PrimaryButton
        as={'a'}
        buttonSize="small"
        type="button"
        style={{ borderRadius: 30, width: 120 }}
      >
        View
      </PrimaryButton>
      <PrimaryButton
        as={'a'}
        buttonSize="small"
        type="button"
        buttonType="primary_white"
        style={{ borderRadius: 30, width: 120 }}
      >
        Reject
      </PrimaryButton>
    </MobileButtonsDiv>
  )
}

export interface SubmissionCardProps {
  drawingShortId: string
  imgSrc: string
  title: string
  createdAt: Date
  displayName: string
}

function SubmissionCard(props: SubmissionCardProps) {
  // const { data: page } = trpc.useQuery(
  //   ['page.byDrawingShortId', { chainId: DEFAULT_CHAIN_ID, drawingShortId: drawingShortId! }],
  //   { enabled: !!drawingShortId },
  // )

  // if (!page) {
  //   return <div />
  // }

  const { drawingShortId, imgSrc, title, createdAt, displayName } = props

  return (
    <SubmissionCardOuterContainer>
      <SubmissionCardDiv>
        <SubmissionCardLeft {...props} />
        <div style={{ flexGrow: 1, minWidth: 36 }} />
        <SubmissionCardImage src={imgSrc} />
      </SubmissionCardDiv>
      <MobileButtonsDiv>
        <Link
          passHref={true}
          href={{
            pathname: '/drawing/[shortId]',
            query: {
              shortId: drawingShortId,
            },
          }}
        >
          <PrimaryButton
            as={'a'}
            buttonSize="small"
            type="button"
            style={{ borderRadius: 30, width: 120 }}
          >
            View
          </PrimaryButton>
        </Link>
        {/* <PrimaryButton
        as={'a'}
        buttonSize="small"
        type="button"
        buttonType="primary_white"
        style={{ borderRadius: 30, width: 120 }}
      >
        Reject
      </PrimaryButton> */}
      </MobileButtonsDiv>
    </SubmissionCardOuterContainer>
  )
}

export default SubmissionCard
